
const MAP_STATE_KEY = "mapState_v2";
export const CLEAR_MAP_SELECTION_EVENT = "reelitpro:clear-map-selection";

export const MapStateManager = {
  /**
   * Save current map state to sessionStorage
   */
  save(mapInstance, overlayState = null) {
    if (!mapInstance) return;

    const center = mapInstance.getCenter();
    const state = {
      lat: center.lat,
      lng: center.lng,
      zoom: mapInstance.getZoom(),
      timestamp: Date.now(),
      overlay: overlayState ? {
        isOpen: overlayState.isOpen,
        tab: overlayState.tab,
        lat: overlayState.lat,
        lng: overlayState.lng,
        placeName: overlayState.placeName,
      } : null,
    };

    try {
      sessionStorage.setItem(MAP_STATE_KEY, JSON.stringify(state));
      console.log("💾 Map state saved:", state);
    } catch (err) {
      console.warn("Failed to save map state:", err);
    }
  },

  /**
   * Load map state from sessionStorage
   */
  load() {
    try {
      const stored = sessionStorage.getItem(MAP_STATE_KEY);
      if (!stored) return null;

      const state = JSON.parse(stored);
      
      // Expire after 30 minutes
      if (Date.now() - state.timestamp > 30 * 60 * 1000) {
        this.clear();
        return null;
      }

      console.log("📂 Map state loaded:", state);
      return state;
    } catch (err) {
      console.warn("Failed to load map state:", err);
      return null;
    }
  },

  /**
   * Clear saved state
   */
  clear() {
    sessionStorage.removeItem(MAP_STATE_KEY);
    console.log("🗑️ Map state cleared");
  },

  clearOverlay() {
    try {
      const stored = sessionStorage.getItem(MAP_STATE_KEY);
      if (!stored) return;

      const state = JSON.parse(stored);
      sessionStorage.setItem(
        MAP_STATE_KEY,
        JSON.stringify({
          ...state,
          timestamp: Date.now(),
          overlay: null,
        })
      );
    } catch (err) {
      console.warn("Failed to clear saved map overlay:", err);
      this.clear();
    }
  },

  /**
   * Check if we should restore (not on initial page load)
   */
  shouldRestore() {
    const state = this.load();
  if (!state) return false;

    // Only restore if state exists and is recent (< 5 min)
    const age = Date.now() - state.timestamp;
  return age < 5 * 60 * 1000; // 5 minutes
  },
};
